/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const TooltipComponent = ({
  btnText,
  icon = 'exclamation-circle',
  position = 'bottom',
  trigger = 'focus',
  style = { position: 'fixed', width: '280px' },
  text,
  size = '1x'
}) => {
  return (
    <OverlayTrigger
      trigger={trigger}
      placement={position}
      overlay={
        <Tooltip className="my-tooltip text-start" style={style} id="tooltip">
          {text}
        </Tooltip>
      }
    >
      {btnText || (
        <Button className="ms-1 p-0 lh-1 border-0 shadow-none bg-transparent text-600 fs--1">
          <FontAwesomeIcon icon={icon} size={size} />
        </Button>
      )}
    </OverlayTrigger>
  );
};

export default TooltipComponent;
